import { Box, Container, Grid, GridItem } from "@chakra-ui/react"
import {Users} from "./Users"

const SKILLS = ['Javascript', 'React', 'Git', 'Python', 'Django', 'Rust']


export const FindAMentor = () => (
  <Container centerContent={false} margin='1'>
    <Box textAlign='left'>
      <Box fontSize='75px' paddingTop='5' paddingBottom='2'>
        mentorXmentee
      </Box>
      <Box fontSize='30px' paddingTop='5' paddingBottom='2'>
        Mentors Matched to You
      </Box>
      <Users />
    </Box>

    <Box textAlign='left' paddingBottom={6}>
      <Box paddingTop='10' paddingBottom='2' fontWeight='semibold'>
        Powered by KABOOM
      </Box>
    </Box>
  </Container>
)